import(/* webpackMode: "eager", webpackExports: ["ClientLanguageProvider"] */ "/builds/developers/frontend/node_modules/@inlang/paraglide-next/dist/paraglide-next/src/app/providers/ClientLanguageProvider.js");
;
import(/* webpackMode: "eager" */ "/builds/developers/frontend/node_modules/next/dist/client/link.js");
